export default __webpack_public_path__ + "static/media/logo.9f966f79.jpg";